export function getTotalCost(total) {
  return parseFloat(total).toFixed(2).replace('.00', '');
}